import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../instance";
import { baseURLRef } from "../../utils";
 
const initialState = {
  glbLoading: false,
  sideMenuCollapsed: false,
  loading: false,
  menuLoading: false,
  menuData: [],

  refetch: false,
  refetchKey: "",

  refetch1: false,
  refetchKey1: "",
  openKeys: [],
  subdomain: "",
};

export const downloadFiles = createAsyncThunk(
  "graduate/downloadFiles",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${baseURLRef.current}/api/v2/onboard/view-file?attrType=${
          data?.attrType ?? ""
        }&fileName=${data?.fileName ?? ""}`,
        { responseType: "blob" }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const fetchMenu = createAsyncThunk("menuSlice/fetchMenu", async () => {
  const res = await axiosInstance
    .get(`/api/v1/menu`)
    .then((res) => res.data?.data?.result);
  return res;
});

export const downloadExcel = createAsyncThunk(
	"sms/downloadExcel",
	async (data, { rejectWithValue }) => {
	let saveUrl = data.url;
	delete data.url;
	  try {
		const response = await axiosInstance.post(`/${saveUrl}`, data, {
		  responseType: "blob",
		}); 
    return {
      data: response.data,
      headers: response.headers,
    }; 
	  } catch (error) {
		return rejectWithValue(error.response.data);
	  }
	}
  );


export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    handleSideMenuCollapse: (state, action) => {
      state.sideMenuCollapsed = action.payload;
    },

    setRefetchKey: (state, action) => {
      state.refetchKey = action.payload;
    },
    setRefetch: (state) => {
      state.refetch = !state.refetch;
    },

    setRefetchKey1: (state, action) => {
      state.refetchKey1 = action.payload;
    },
    setRefetch1: (state) => {
      state.refetch1 = !state.refetch1;
    },
    setOpenKeys: (state, action) => {
      state.openKeys = action.payload;
    },
    setSubdomain: (state, action) => {
      state.subdomain = action.payload;
    },
    clearGlobalObj: () => {
      return { ...initialState };
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(downloadFiles.pending, (state) => {
        state.loading = true;
      })
      .addCase(downloadFiles.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(downloadFiles.rejected, (state) => {
        state.loading = false;
      })

      .addCase(fetchMenu.pending, (state) => {
        state.menuLoading = true;
      })
      .addCase(fetchMenu.fulfilled, (state, action) => {
        state.menuLoading = false;
        state.menuData = action.payload;
      })
      .addCase(fetchMenu.rejected, (state) => {
        state.menuLoading = false;
        state.menuData = [];
      })

      .addCase(downloadExcel.pending, (state) => {
        state.glbLoading = true;
      })
      .addCase(downloadExcel.fulfilled, (state, action) => {
        state.glbLoading = false;
      })
      .addCase(downloadExcel.rejected, (state) => {
        state.glbLoading = false;
      });
  },
});

export default globalSlice.reducer;
export const {
  handleSideMenuCollapse,
  setRefetchKey,
  setRefetch,
  setRefetchKey1,
  setRefetch1,
  setOpenKeys,
  setSubdomain,
  clearGlobalObj,
} = globalSlice.actions;
